export default __webpack_public_path__ + "static/media/parshj.f58e5c69.jpg";